import React from 'react'
import {Button, buttonTypes} from '../../Global/Button';

export default function NextPageButton(props) {

  if(!props.shouldHaveNextPageButton) return null

  return (
    <div className="pageNavigation">
        <Button className="next-page" type={buttonTypes.next} onClick={props.onNextPageClick} disabled={!props.pageNavEnabled} />
    </div>
  )
}
